// ===== Game persistence (localStorage) =====
// Saves the in-progress game so the player can "Continua partita", plus local
// statistics. Designed to be swappable for a backend/cloud sync in the future.

const GAME_KEY = 'scopa.game.v1';
const STATS_KEY = 'scopa.stats.v1';

export function saveGame(state) {
  try {
    if (!state || state.phase === 'gameOver') {
      localStorage.removeItem(GAME_KEY);
      return;
    }
    localStorage.setItem(GAME_KEY, JSON.stringify(state));
  } catch (e) {
    /* noop */
  }
}

export function loadGame() {
  try {
    const raw = localStorage.getItem(GAME_KEY);
    if (!raw) return null;
    const state = JSON.parse(raw);
    if (state.phase === 'gameOver') return null;
    return state;
  } catch (e) {
    return null;
  }
}

export function hasSavedGame() {
  return !!loadGame();
}

export function clearGame() {
  try {
    localStorage.removeItem(GAME_KEY);
  } catch (e) {
    /* noop */
  }
}

export function loadStats() {
  try {
    const raw = localStorage.getItem(STATS_KEY);
    if (!raw) return { played: 0, won: 0, lost: 0 };
    return JSON.parse(raw);
  } catch (e) {
    return { played: 0, won: 0, lost: 0 };
  }
}

export function recordResult(winner) {
  const stats = loadStats();
  stats.played += 1;
  if (winner === 'player') stats.won += 1;
  else stats.lost += 1;
  try {
    localStorage.setItem(STATS_KEY, JSON.stringify(stats));
  } catch (e) {
    /* noop */
  }
  return stats;
}
